import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { AdminProvider } from "@/context/AdminContext";
import { StoreProvider } from "@/context/StoreContext";

// Console telif uyarısı
console.clear();
console.log(
  "%c⚠️ DİKKAT! ⚠️",
  "color: red; font-size: 40px; font-weight: bold; text-shadow: 2px 2px 4px #000;"
);
console.log(
  "%cBu yazılım tamamen CrackOyun'a aittir.",
  "color: #ff6b6b; font-size: 18px; font-weight: bold;"
);
console.log(
  "%cTüm hakları saklıdır. İzinsiz kopyalama ve dağıtım yasaktır.",
  "color: #ffa500; font-size: 14px;"
);
console.log(
  "%c🔒 Bu konsolu kapatın ve normal kullanıma devam edin.",
  "color: #4ecdc4; font-size: 14px; font-weight: bold;"
);
console.log(
  "%c© " + new Date().getFullYear() + " CrackOyun - Tüm Hakları Saklıdır",
  "color: #888; font-size: 12px;"
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AdminProvider>
      <StoreProvider>
        <App />
      </StoreProvider>
    </AdminProvider>
  </React.StrictMode>,
);
